import { Elastic, TweenLite } from "gsap";
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { ITimeout } from "../../../Context/Timeout";
import { Point, Rect, Scale, TranslateScreen1To1 } from "../../../MyHelpers";
import { IReadOnlyResourceManager, ResourceManager } from "../../../ResourceManager/ResourceManager";
import { service } from "../../../services";
import { IBonusStartConfig } from "../../SlotGame";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldState } from "../SpinAndHold/SpinAndHoldState";
import { ExtendedSpinAndHold } from "./ExtendedSpinAndHold";

export class ExtendedSpinAndHold_2Screen extends ExtendedSpinAndHold
{
	public override UpdateSpinSpeed(changeSpeedParams: ChangeSpeedParams) {
		throw new Error("Method not implemented.");
	}
   
    protected override BonusName(): string
	{
		return "ExtendedSpinAndHold";
	}

	protected timeoutCometShowtime : ITimeout = null;
	protected isMovedWincontainer: boolean = false;
    public constructor(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration) {
		super(gameName, params, config);
		//aling background spin and Hold 
		this.backgroundSpinHoldGame.style.bottom = Scale.Ypx(-1080);
		this.timeoutCometShowtime = this.systemContext.TimingContext().CreateTimeout("timeoutCometShowtime", 1000, () => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex])})	
    }
	//use for fix commets destination commet
	protected override DesinationComet(): Point {		
		let destination: Point = TranslateScreen1To1(new Rect(0, Scale.W(1080), Scale.W(1920), Scale.H(1080))).Center();
		//change position for bottom because win container its move from bottom to top when sra comets its display
		if (this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row < this.spinnableReels2.GetWindowSymbolSize().Height / 2) {								
			destination = TranslateScreen1To1(new Rect(0, Scale.W(2200), Scale.W(1920), Scale.H(1080))).Center();
		}
		return destination 
	}

	//fix position on messagecontainer intro and final 
	protected override PrepareIntroMessage(resourceManager: ResourceManager): void {
		super.PrepareIntroMessage(resourceManager);
		this.introMessageContainer.style.bottom = Scale.Ypx(-1080);
	}

	protected override PrepareFinalMessage(resourceManager: ResourceManager): void {
		super.PrepareFinalMessage(resourceManager);
		//this.introMessageContainer.style.position = "relative";
		this.finalMessageContainer.style.bottom = Scale.Ypx(-1080);
	}
	//Hide jackpot into bonus
	public override Start(): void { 
		super.Start();
		//put win container in original position
		TweenLite.to(this.winContainer, 0.5, {
		 	y: Scale.Y(0),
		});
		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 0
			});
		}
		this.animBottomToTopWinContainer.restart();
		this.animBottomToTopWinContainer.pause();
	}

	//show jackpot on base game 
	protected override OnFinalMessageEnd(): void {
		super.OnFinalMessageEnd()
		if(globalThis.jackpotDisplayGlobal != null){
			globalThis.jackpotDisplayGlobal.View().style.opacity = "1";
		}
	}
	

	protected animBottomToTopWinContainer : TweenLite = null;
	protected override async winContainerLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.winContainerLoaded(resourceManager);
		this.winContainer.style.top = Scale.Ypx(380);
		this.winContainer.style.left = Scale.Ypx(0);
		this.winContainer.style.position = "relative";


		this.animBottomToTopWinContainer = 	TweenLite.to(this.winContainer, 1, {
			y: Scale.Y(-1020),
		}).pause();

	}

	protected override WinCountShow() {		

		//change position for winContainer 
		if (this.scatterPositions[0].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) {
			//top position
			this.winContainer.style.top = Scale.Ypx(380);						
			this.isMovedWincontainer = false;
		} else {
			//bottom postion
			this.winContainer.style.top = Scale.Ypx(1400);
			this.isMovedWincontainer = true;										
		}

		//anim win and show container
		TweenLite.fromTo(this.winContainer, 1,
			{ x: Scale.Xpx(1920), display: "none", alpha: 0 },
			{ x: Scale.X(0), display: "flex", alpha: 1, ease: Elastic.easeOut.config(0.50, 0.4) }
		);

		//hide jackpotdisplay dont need use it for extended 2 Screens
		if (globalThis.jackpotDisplayGlobal != null) {
			TweenLite.to(globalThis.jackpotDisplayGlobal.View(), 2.5, {
				alpha: 0
			});
		}
	}

	protected override NextComet() {
		//this.isShowed = true;
		this.currentScatterCometIndex++;
		if (this.currentScatterCometIndex >= this.scatterPositions.length) {
			// Log.Debug(this.logGroup, "Comets complete");			
			this.panel.SetWin(service.moneyFormatter.FormatCreditCurrentDenom(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents), service.moneyFormatter.FormatCurrency(this.simpleConfigSpinAndHold.WinSinceGameStart.TotalWin.InCents))
			this.timeoutFinalMessageState.Start();
		}
		else {
			if (SpinAndHoldState.CometCollect == this.stateMachine.State()) {
				this.isShowed = false;
				if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isMovedWincontainer == true) {
					this.animBottomToTopWinContainer.play();
					//its moved need turn of flag for dont move all time
					this.isMovedWincontainer = false;
					//add some delay for wait move container and later show comet anim
					this.timeoutCometShowtime.Start();
					//setTimeout(() => { this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]); }, 1000)
				} else {
					//jumps to cometshowTime dosent need add delay here
					this.CometShowtime(this.scatterPositions[this.currentScatterCometIndex]);
				}
			}
		}
	}

	public override Prepare(startConfig: IBonusStartConfig) {
		super.Prepare(startConfig);
		//reset flag for move container 
		this.isMovedWincontainer = false;
		this.isWinContainerShowWinMovedJumped = false;
		//need quit translate for restar to original position 
		//this.winContainer.style.transform = "translate(0px, 0px)";				
	}

	protected isWinContainerShowWinMovedJumped = false;
	protected override RequestStopsCommetShowWin() {
		super.RequestStopsCommetShowWin();		
		this.timeoutCometShowtime.Stop();
		if ((this.scatterPositions[this.currentScatterCometIndex].AwardOptionPosition.Row >= this.spinnableReels2.GetWindowSymbolSize().Height / 2) && this.isWinContainerShowWinMovedJumped == false) {
			this.animBottomToTopWinContainer.pause();	
			this.winContainer.style.transform = "translate(0px, 0px)";			
			this.winContainer.style.top = Scale.Ypx(380);
			this.isWinContainerShowWinMovedJumped = true;
		}
	}

	protected override async CometsLoaded(resourceManager: IReadOnlyResourceManager): Promise<void> {
		await super.CometsLoaded(resourceManager);		
		this.skipMessageCommets.style.bottom = Scale.Ypx(-1080);
	}
}


export interface IExtendedSpinAndHoldFactory_2Screen {
	CreateExtendedSpinAndHold_2Screen(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): ExtendedSpinAndHold;
}



export class ExtendedSpinAndHoldFactory_2Screen  implements IExtendedSpinAndHoldFactory_2Screen {

	public CreateExtendedSpinAndHold_2Screen(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): ExtendedSpinAndHold {
		return new ExtendedSpinAndHold_2Screen(gameName, params, config);
	}
}
